import axios from "axios";
import { storage } from "@/common/services/storage";
import { API_ENDPOINT } from "@/common/constants";
import { logout } from "@/common/services/auth.service";

const axiosAuthClient = axios.create({
  baseURL: API_ENDPOINT,
  headers: { "Content-Type": "application/json", Accept: "application/json" },
});

axiosAuthClient.interceptors.request.use(async (config) => {
  const token = await storage.get("token");
  const publicPaths = ["/login", "/signup", "/password-reset", "/auth/callback"];
  if (!token && !publicPaths.includes(document.location.pathname)) {
    document.location = "/login";
  }

  config.headers ??= {};
  config.headers.Authorization = `Bearer ${token}`;

  return config;
});

axiosAuthClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error?.response?.status === 401) {
      await logout();
      if (!/\/login/.test(document.location.pathname)) {
        document.location = "/login";
      }
    }

    return Promise.reject(error);
  },
);

export default axiosAuthClient;
